import { Component, type ReactNode } from "react";
import { capture } from "@orb-labs/orby-react";
import { ErrorEvents, WEB_FONT_STACK_MONO } from "@orb-labs/orby-react/bullrun";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    capture(ErrorEvents.UNEXPECTED_ERROR, {
      error_type: "react_boundary",
      error_name: error.name,
      error_message: error.message,
    });
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div
          style={{
            padding: "24px",
            color: "#ff4d6a",
            fontFamily: WEB_FONT_STACK_MONO,
            fontSize: "14px",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <h2 style={{ color: "#eeeef2", marginBottom: "16px" }}>Something went wrong</h2>
          <pre style={{ overflow: "auto", whiteSpace: "pre-wrap" }}>{this.state.error.message}</pre>
          <pre style={{ marginTop: "16px", fontSize: "12px", opacity: 0.8 }}>{this.state.error.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
